<p-dialog [header]="protocolHeader" [modal]="true" [(visible)]="loadDialogView" [style]="{ width: '60rem' }"
    (onHide)="closeDialog(false)">
    @for (tab of protocolAttributeData?.tabs; track tab; let i = $index) {
    <div>
        <app-mi-form [attributeLabels]="attributeLabels" [attributeValues]="attributeValues" [moduleName]="moduleName"
            [groups]="tab.groups" (saveData)="onSaveSponsor($event)" (previousClick)="onPreviousClick()"
            [showImg]="true" [isMultipleFilesUpload]="true" [submitBtnText]="nextBtnLabel"
            [previousBtnText]="previousBtnLabel" [activeIndex]="activeIndex" [showCancelButton]="true"
            [saveBtnId]="prefixToAttachForButtonIdToUniquelyIdentifyButton + tab.tabCode"
            (onCancel)="closeDialog(false)"></app-mi-form>
    </div>

    }
</p-dialog>